export default "__VITE_ASSET__c4961326__"